export const collaborators = [
  {
    id: "darryl-lim",
    name: "Darryl Lim",
    firstname: "Darryl",
    designation: "Undergraduate/Master's Student, SUTD",
    duration: "Dec 2025 - Feb 2026",
    projectIds: [
      "acpchat"
    ]
  },
  {
    id: "john-henry-lim",
    name: "John-Henry Lim",
    firstname: "John-Henry",
    designation: "Undergraduate/Master's Student, SUTD",
    duration: "Dec 2025 - Feb 2026",
    projectIds: [
      "acpchat"
    ]
  },
  {
    id: "melanie-quek",
    name: "Melanie Quek",
    firstname: "Melanie",
    designation: "Product Manager, Digital Experience, CapitaLand",
    duration: "Mar 2025 - Jan 2026",
    projectIds: [
      "acpchat"
    ]
  },
  {
    id: "pin-sym-foong",
    name: "Pin Sym Foong",
    firstname: "Pin Sym",
    designation: "Head Of Design - TeleHealth Core, NUS",
    duration: "Mar 2025 - Feb 2026",
    projectIds: [
      "acpchat"
    ]
  },
  {
    id: "swarangi-mehta",
    name: "Swarangi Mehta",
    firstname: "Swarangi",
    designation: "PhD Student (previously Research Associate), SUTD",
    duration: "Jun 2025 - Present",
    projectIds: [
      "acpchat"
    ]
  },
  {
    id: "quoc-nam-nguyen",
    name: "Quoc-Nam Nguyen",
    firstname: "Quoc-Nam",
    designation: "PhD Student (previously Research Assistant), SUTD",
    duration: "Apr 2025 - Present",
    projectIds: [
      "sense"
    ]
  },
  {
    id: "chenyu-zhao",
    name: "Chenyu Zhao",
    firstname: "Chenyu",
    designation: "Master's Student, SUTD",
    duration: "Nov 2024 - Jan 2026",
    projectIds: [
      "acpchat"
    ]
  },
  {
    id: "gionnieve-lim",
    name: "Gionnieve Lim",
    firstname: "Gionnieve",
    designation: "PhD Student, SUTD",
    duration: "Jun 2024 - May 2025",
    projectIds: [
      "truthguardian"
    ]
  },
  {
    id: "bryan-tan",
    name: "Bryan Chen Zhengyu Tan",
    firstname: "Bryan",
    designation: "PhD Student, SUTD",
    duration: "Jun 2024 - May 2025",
    projectIds: [
      "truthguardian"
    ]
  },
  {
    id: "weiyan-shi",
    name: "Weiyan Shi",
    firstname: "Weiyan",
    designation: "PhD Student, SUTD",
    duration: "Jun 2024 - May 2025",
    projectIds: [
      "truthguardian"
    ]
  },
  {
    id: "ming-hui-chew",
    name: "Ming Hui Chew",
    firstname: "Ming Hui",
    designation: "Undergraduate Student, SUTD",
    duration: "Jun 2024 - May 2025",
    projectIds: [
      "truthguardian"
    ]
  },
  {
    id: "ming-shan-hee",
    name: "Ming Shan Hee",
    firstname: "Ming Shan",
    designation: "PhD Student, SUTD",
    duration: "Jun 2024 - May 2025",
    projectIds: [
      "truthguardian"
    ]
  },
  {
    id: "charlotte-ng",
    name: "Charlotte Ng Si Min",
    firstname: "Charlotte",
    designation: "Undergraduate/Master's Student, SUTD",
    duration: "Nov 2023 - Apr 2025",
    projectIds: [
      "blossom"
    ]
  },
  {
    id: "kohleen-fortuno",
    name: "Kohleen Tijing Fortuno",
    firstname: "Kohleen",
    designation: "Master's Student, SUTD",
    duration: "Oct 2022 - Jul 2024",
    projectIds: []
  },
  {
    id: "chun-mun-chia",
    name: "Chia Chun Mun",
    firstname: "Chun Mun",
    designation: "Undergraduate Student, SUTD",
    duration: "Sep 2022 - Dec 2023",
    projectIds: []
  }
];
